import { aiAgentsHomeStateName } from 'modules/application/detail/aiAgents/index';
import { AiAgentsFeatures } from 'modules/application/detail/aiAgents/AiAgentsFeatures';
import './CreateAiAgent.scss';
const BLIP_AI_AGENT_PUBLISH_TEMPLATE = 'blip_aiAgent_publish';
const CLIENT_CREDENTIALS_BUCKET_KEY = 'blip_ai_suite:client_credentials';
const AI_AGENT_REDIRECT_BUCKET_KEY_PROD = 'blip_ai_suite_bot_config';
const AI_AGENT_REDIRECT_BUCKET_KEY_DEV = 'blip_ai_suite_bot_config_working';
const AI_AGENT_BUILDER_WORKING_FLOW = 'blip_portal:builder_working_flow';
const ASSISTANT_ID_BUCKET_KEY = 'blip_ai_suite_assistant_id';
const CREATE_CHATBOT = 'aiagent-create-chatbot-clicked';
const AI_AGENT_LAYOUT = 'AiAgent';
const BLIP_AI_AGENTS_ASSISTANT_ID = 'blip_ai_agents_assistant_id';
const BLIP_AI_AGENTS_PROFILE_CONFIG = 'blip_ai_agents_profile_config';
const BLIP_AI_AGENTS_PROFILE_CONFIG_WORKING = 'blip_ai_agents_profile_config_working';
const BLIP_AI_AGENTS_BOT_CONFIG = 'blip_ai_agents_bot_config';
const BLIP_AI_AGENTS_BOT_CONFIG_WORKING = 'blip_ai_agents_bot_config_working';
export class CreateAIAgentController {
    static $inject = ['$state', '$translate', 'AuthenticationService', 'ContextProcessorService', 'CreateApplicationService', 'LoadingService', 'SegmentService', 'AnswersService', 'BucketService', 'AccountService2', 'BlipToastService', 'AI_AGENT_STORAGE_BASE_URL'];
    constructor($state, $translate, AuthenticationService, ContextProcessorService, CreateApplicationService, LoadingService, SegmentService, AnswersService, BucketService, AccountService2, BlipToastService, AI_AGENT_STORAGE_BASE_URL) {
        'ngInject';
        this.$state = $state;
        this.$translate = $translate;
        this.AuthenticationService = AuthenticationService;
        this.ContextProcessorService = ContextProcessorService;
        this.CreateApplicationService = CreateApplicationService;
        this.LoadingService = LoadingService;
        this.SegmentService = SegmentService;
        this.AnswersService = AnswersService;
        this.BucketService = BucketService;
        this.AccountService2 = AccountService2;
        this.BlipToastService = BlipToastService;
        this.AI_AGENT_STORAGE_BASE_URL = AI_AGENT_STORAGE_BASE_URL;
        this.backFromCreateStep = () => {
            this.$state.go('auth.application.list');
        };
        this.onInputNameChange = (event) => {
            this.aiAgent.name = event.detail.value;
        };
        this.onInputCompanyProductNameChange = (event) => {
            this.aiAgent.companyProductName = event.detail.value;
        };
        this.onSelectToneAndVoiceChange = (event) => {
            this.aiAgent.toneAndVoice = event.detail.value;
        };
        this.onHasHumanServiceToggle = (event) => {
            this.aiAgent.hasHumanService = event.detail.checked;
        };
        this.validateForm = () => {
            const { name, companyProductName, toneAndVoice } = this.aiAgent;
            return name.length > 0 && companyProductName.length > 0 && toneAndVoice.length > 0;
        };
        this.initialize();
    }
    async initialize() {
        this.isValidForm = false;
        this.aiAgent = {
            name: '',
            companyProductName: '',
            toneAndVoice: '',
            hasHumanService: false,
        };
        this.toneAndVoiceOptions = [
            { label: await this.getTranslation('friendly'), value: 'amigavel' },
            { label: await this.getTranslation('funny'), value: 'divertido' },
            { label: await this.getTranslation('technical'), value: 'tecnico' },
        ];
    }
    async getTranslation(key) {
        return await this.$translate(`createApplication.aiAgent.create.basicConfiguration.toneAndVoice.options.${key}`);
    }
    async createAiAgent() {
        try {
            this.LoadingService.startLoading(false);
            if (!this.validateForm()) {
                return;
            }
            const assistant = {
                assistantName: this.aiAgent.name,
                tenantId: '',
                assistantId: '',
                configs: {},
                createdAt: '',
                updatedAt: '',
            };
            const assistantConfiguration = {
                assistantId: '',
                invalidAnswer: '',
                guidelines: '',
                redirectGuidelines: '',
                assistantName: this.aiAgent.name,
                companyName: this.aiAgent.companyProductName,
                profile: this.aiAgent.toneAndVoice,
                agentType: '',
            };
            const application = await this.createApplicationAsync({ name: this.aiAgent.name, layout: AI_AGENT_LAYOUT }, BLIP_AI_AGENT_PUBLISH_TEMPLATE);
            const botCredentials = await this.generateAgentCredentialsAsync(application.shortName);
            const configuration = await this.createAgentAsync(assistant, assistantConfiguration, botCredentials);
            await this.createBucketAsync(this.aiAgent.hasHumanService, configuration.assistantId, botCredentials);
            this.createApplicationTrack(application);
            this.goToApplicationDetails(application);
        }
        catch (err) {
            const errorMessage = await this.$translate('createApplication.aiAgent.create.toast.error');
            const title = await this.$translate('createApplication.aiAgent.create.toast.tittle');
            this.BlipToastService.show('danger', {
                title: title,
                msg: errorMessage,
            });
            this.createApplicationTrack({ template: BLIP_AI_AGENT_PUBLISH_TEMPLATE }, false, err.message);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    createApplicationTrack(application, success = true, error) {
        this.SegmentService.createApplicationTrack({
            trackEvent: CREATE_CHATBOT,
            application: application,
            payload: {
                template: application?.template,
                marketplaceId: application?.marketplace?.id,
                voiceTone: this.aiAgent.toneAndVoice,
                hasHumanService: this.aiAgent.hasHumanService,
                companyName: this.aiAgent.companyProductName,
                assistantName: this.aiAgent.name,
                creationStatus: success ? 'success' : 'error',
                errorType: error,
            },
        });
    }
    async createBucketAsync(hasHumanService, assistantId, botCredentials) {
        try {
            const aiAgentTemplateWorking = await this.getAiAgentTemplateAsync();
            const defaultLanguage = await this.getDefaultLanguageAsync();
            const aiAgentRedirect = {
                culture: defaultLanguage,
                redirect: {
                    human: hasHumanService,
                    service: false,
                    serviceName: '',
                },
            };
            const profileConfiguration = {
                culture: defaultLanguage,
            };
            const redirectStrategy = {
                negativeRedirectStrategy: {
                    human: hasHumanService,
                    service: false,
                    serviceName: '',
                    retryLimit: 3,
                },
                positiveRedirectStrategy: {
                    enable: false,
                    serviceName: '',
                },
                inactiveRedirectStrategy: {
                    enable: false,
                    serviceName: '',
                },
                unavailabilityRedirectStrategy: {
                    enable: true,
                    serviceName: '',
                },
                regexRedirectServiceStrategy: {
                    enable: false,
                    patterns: [],
                    serviceName: '',
                },
                regexRedirectHumanStrategy: {
                    enable: false,
                    patterns: [],
                },
            };
            const isEnableAiAgentNewSettings = await AiAgentsFeatures.isEnableAiAgentNewSettings();
            //default configurations
            await this.BucketService.set(AI_AGENT_BUILDER_WORKING_FLOW, aiAgentTemplateWorking, 'application/json');
            await this.BucketService.set(CLIENT_CREDENTIALS_BUCKET_KEY, botCredentials, 'application/json');
            await this.BucketService.set(ASSISTANT_ID_BUCKET_KEY, assistantId, 'text/plain');
            if (isEnableAiAgentNewSettings) {
                //new configurations
                await this.BucketService.set(BLIP_AI_AGENTS_ASSISTANT_ID, assistantId, 'text/plain');
                await this.BucketService.set(BLIP_AI_AGENTS_BOT_CONFIG, redirectStrategy, 'application/json');
                await this.BucketService.set(BLIP_AI_AGENTS_BOT_CONFIG_WORKING, redirectStrategy, 'application/json');
                await this.BucketService.set(BLIP_AI_AGENTS_PROFILE_CONFIG, profileConfiguration, 'application/json');
                await this.BucketService.set(BLIP_AI_AGENTS_PROFILE_CONFIG_WORKING, profileConfiguration, 'application/json');
            }
            else {
                //obsolete configurations
                await this.BucketService.set(AI_AGENT_REDIRECT_BUCKET_KEY_DEV, aiAgentRedirect, 'application/json');
                await this.BucketService.set(AI_AGENT_REDIRECT_BUCKET_KEY_PROD, aiAgentRedirect, 'application/json');
            }
        }
        catch (err) {
            console.error('Failed to create bucket:', err);
            throw new Error('Failed to create bucket');
        }
    }
    async getDefaultLanguageAsync() {
        const userLanguage = (await this.AccountService2.me()).culture;
        return userLanguage;
    }
    async createAgentAsync(assistant, configuration, botCredentials) {
        try {
            assistant = await this.AnswersService.createAssistant(botCredentials, assistant, configuration);
            configuration = {
                ...configuration,
                assistantId: assistant.assistantId,
                tenantId: assistant.tenantId,
                configurationId: assistant.configs.DEV,
                createdAt: assistant.createdAt,
                updatedAt: assistant.updatedAt,
            };
            await this.AnswersService.publishAssistant(configuration);
            return configuration;
        }
        catch (err) {
            console.error('Failed to create agent:', err);
            throw new Error('Failed to create agent');
        }
    }
    async getAiAgentTemplateAsync() {
        try {
            const aiAgentContainerBaseUrl = this.AI_AGENT_STORAGE_BASE_URL;
            const response = await fetch(`${aiAgentContainerBaseUrl}/aiagentstemplates/aiAgentTemplate_working.json`);
            if (!response.ok) {
                throw new Error('Failed to fetch AI agent template');
            }
            const aiAgentTemplate = await response.json();
            return aiAgentTemplate;
        }
        catch (err) {
            throw err;
        }
    }
    async createApplicationAsync(application, template) {
        try {
            application = await this.CreateApplicationService.createApplication(application, template);
            return application;
        }
        catch (err) {
            console.error('An exception occurred while creating the application:', err);
            throw new Error('Failed to create the application');
        }
    }
    async generateAgentCredentialsAsync(botId) {
        try {
            const tenantId = this.ContextProcessorService.tenant.id;
            await this.AnswersService.setRegistration(tenantId, botId, this.AuthenticationService.token);
            const accessToken = await this.AnswersService.replaceAccessToken(tenantId, botId, this.AuthenticationService.token);
            return await this.AnswersService.generateBotCredentials(tenantId, botId, accessToken);
        }
        catch (err) {
            console.error('Failed to generate agent credentials:', err);
            throw new Error('Failed to generate agent credentials');
        }
    }
    async goToApplicationDetails(application) {
        this.$state.go(aiAgentsHomeStateName, {
            shortName: application.shortName,
        });
    }
}
CreateAIAgentController.$inject = ['$state', '$translate', 'AuthenticationService', 'ContextProcessorService', 'CreateApplicationService', 'LoadingService', 'SegmentService', 'AnswersService', 'BucketService', 'AccountService2', 'BlipToastService', 'AI_AGENT_STORAGE_BASE_URL'];
